var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.title),expression:"title"}],staticClass:"btn btn-info",attrs:{"href":_vm.src,"rel":_vm.rel}},[_c('i',{staticClass:"ti-image"})])}
var staticRenderFns = []

export { render, staticRenderFns }